export default "__VITE_ASSET__cRXiEVUy__";